export default __webpack_public_path__ + "static/media/izettle2.73a89cca.png";